import React from 'react';
import Helmet from 'react-helmet';
import SiteHeaderUtils from '../utils/SiteHeaderUtils';
import { RequiresAuthenticatedUser } from './RequiresAuthenticatedUser';

function Inner() {
  return (
    <div className="bow page">
      <Helmet title={SiteHeaderUtils.getCurrentMenu()} />
    </div>
  );
}

export default RequiresAuthenticatedUser(Inner);
